import None from './None';
export default function isMaybe(value) {
    return (value === null || value === void 0 ? void 0 : value._kind) === 'Some' || value === None;
}
//# sourceMappingURL=isMaybe.js.map